import React from 'react'

export type LoadingSpinnerProps = {
  label?: string
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ label = 'Loading…' }) => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="flex items-center gap-3 rounded-lg bg-white px-4 py-3 shadow-sm">
        <svg className="h-5 w-5 animate-spin text-blue-600" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
        </svg>
        <div className="text-sm text-gray-700">{label}</div>
      </div>
    </div>
  )
}

export default LoadingSpinner
